import { useEffect, useState } from 'react';
import { HosApiDashboardScheduledAds } from '../../types/apiTypes';
import {
  DashboardCardTimespan,
  DashboardDataScheduledAds,
} from '../../types/commonTypes';
import { formatTimeString } from '../../lib/dateHelpers';
import { useFetch } from '../useFetch';
import { useOperator } from '../../contexts/OperatorContext';
import { BASE_URL_MAP } from '../../lib/environment';

export const useScheduledAds = () => {
  const [scheduledAds, setScheduledAds] = useState<DashboardDataScheduledAds[]>(
    []
  );
  const { makeRequest, loading, response } = useFetch();
  const operator = useOperator();

  useEffect(() => {
    if (response && !loading) setScheduledAds(mapScheduledAds(response));
  }, [response, loading]);

  const getScheduledAds = (dateRange?: DashboardCardTimespan) => {
    let url = `${BASE_URL_MAP['Hospitality']}/${operator?.id}/Dashboard/Ads`;
    if (dateRange)
      url += `?startDate=${dateRange.startDate.toISOString()}&endDate=${dateRange.endDate.toISOString()}`;

    makeRequest(url, 'get');
  };
  return { scheduledAds, getScheduledAds, loading };
};

const mapScheduledAds = (
  ads: HosApiDashboardScheduledAds[]
): DashboardDataScheduledAds[] => {
  return ads.map((ad: HosApiDashboardScheduledAds) => {
    return {
      name: ad.Name,
      location: ad.Location,
      startDate: formatTimeString(new Date(ad.StartDate)),
    };
  });
};
